import { render, staticRenderFns } from "./PriceItem.vue?vue&type=template&id=20e39d7a"
import script from "./PriceItem.vue?vue&type=script&lang=js"
export * from "./PriceItem.vue?vue&type=script&lang=js"
import style0 from "./PriceItem.vue?vue&type=style&index=0&id=20e39d7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports